<template>
  <div v-if="item">
    <fields-list :item="item" :fields="fields" />
    <season-part :id="id"/>
    <div class="save-panel">
      <button class="btn  btn-warning btn-icon" @click="updateItem">
        <span class="ti-save"></span>{{ 'save' | setText('Сохранить') }}
      </button>
    </div>
  </div>
</template>
<script>
import { cardUpdate, cardContent, pushLang } from "@/plugins/functions";
import SeasonPart from "./SeasonPart.vue";
export default {
  components: {
    SeasonPart
  },
  data: () => ({
    cardLink: "business/seasons",
    cardSetLink: "business/seasons",
    item: null,
    fields: [
      {
        key: "title",
        label: "Название",
        type: "field",
        textType: "text",
        isMultiLang: true,
      },
      {
        col: 'col-12 col-md-6',
        key: "from_at",
        label: "Начало учебного сезона",
        type: "date",
        textType: "text",
        readonly: false,
        dateFormat: true,
      },
      {
        col: 'col-12 col-md-6',
        key: "till_at",
        label: "Окончание учебного сезона",
        type: "date",
        textType: "text",
        readonly: false,
        dateFormat: true,
      },
    ],
  }),
  props: ["id"],
  async created() {
    this.item = await this.cardContent(this.cardLink, this.id);
  },
  methods: {
    cardUpdate: cardUpdate,
    cardContent: cardContent,
    pushLang: pushLang,
    async updateItem() {
      let item = await this.cardUpdate(this.cardSetLink, this.item, this.fields);
      // if (item){
      //   this.item = item;
      // }
    },
  },
};
</script>
<style>
</style>
